import React from 'react'

export default function BrandLogo() {
  return (
    <svg
      width="46"
      height="42"
      viewBox="0 0 46 42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M45 30v2l-10 9a1 1 0 01-1-1V19L45 8v22z" fill="#E44D60" />
      <path d="M38 1h-1L23 15h-1v15l1 1 11-11L45 8l-7-7z" fill="#E4BD7A" />
      <path d="M0 30l1 2 9 9a1 1 0 001-1V19L0 8v22z" fill="#1C798A" />
      <path d="M9 1H7L0 8l11 12 12 11V15L9 1z" fill="#77B691" />
    </svg>
  )
}
